export default {
	tenantId: "coverHealth_dev",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "coverhealth--dev"
	}
}
